"use client";import{jsx as e}from"react/jsx-runtime";import{useRef as r}from"react";import{twMerge as s}from"tailwind-merge";import{useProgressAnimation as t}from"./useProgressAnimation.js";
/**
 * ProgressIndicator
 *
 * 진행 상태를 시각적으로 표시하는 프로그레스 바 컴포넌트입니다.
 * Safari 브라우저에서의 성능 최적화를 위해 requestAnimationFrame을 사용하여 애니메이션을 구현했습니다.
 *
 * @example
 * ```tsx
 * <ProgressIndicator value={75} />
 * <ProgressIndicator value={50} className="h-2" progressClassName="bg-secondary" />
 * ```
 */const i=({className:i,progressClassName:a,value:d})=>{const l=r(null);
// 커스텀 훅을 사용하여 애니메이션 처리
t(d,l);/*#__PURE__*/
return e("div",{"data-testid":"design-system-progress-indicator",className:s("h-1 w-full overflow-hidden rounded-full",i),children:/*#__PURE__*/e("div",{className:"h-full bg-w-gray-100","data-testid":"design-system-progress-indicator--background",style:{WebkitTransformStyle:"preserve-3d",transformStyle:"preserve-3d"},children:/*#__PURE__*/e("div",{ref:l,"data-testid":"design-system-progress-indicator--progress",className:s("h-full",a,d>0?"bg-primary":"hidden"),style:{transform:"translate3d(-100%, 0, 0)",WebkitTransform:"translate3d(-100%, 0, 0)",willChange:"transform",WebkitBackfaceVisibility:"hidden",backfaceVisibility:"hidden"}})})})};export{i as ProgressIndicator};
